import { Capacitor } from '@capacitor/core';
import { PushNotifications } from '@capacitor/push-notifications';
import { registerDeviceToken } from '../api/notifications';
import { requestForToken } from './firebase';

export const setupCapacitorPush = () => {
  if (Capacitor.isNativePlatform()) {
    try {
      // Request permission to use push notifications
      PushNotifications.requestPermissions().then((result) => {
        if (result.receive === 'granted') {
          PushNotifications.register().catch(err => {
            console.warn('Push registration skipped/failed:', err);
          });
        }
      }).catch(err => {
        console.warn('Push permission request failed:', err);
      });

      // On success, we should be able to receive notifications
      PushNotifications.addListener('registration', (token) => {
        console.log('Push registration success, token: ' + token.value);
        localStorage.setItem('fcm_device_token', token.value);
        
        // Determine device type
        const deviceType = Capacitor.getPlatform(); // 'android' or 'ios'
        
        // Register token with backend
        registerDeviceToken(token.value, deviceType).catch(err => {
          console.error('Failed to register device token with backend:', err);
        });
      });

      // Some issue with our setup and push will not work
      PushNotifications.addListener('registrationError', (error) => {
        console.error('Error on registration: ' + JSON.stringify(error));
      });

      // Show us the notification payload if the app is open on our device
      PushNotifications.addListener('pushNotificationReceived', (notification) => {
        console.log('Push received: ' + JSON.stringify(notification));
        // In a real app, you might show a toast or local notification here
        // Since it's handled by Header fetching count, we can just log it
      });

      // Method called when tapping on a notification
      PushNotifications.addListener('pushNotificationActionPerformed', (notification) => {
        console.log('Push action performed: ' + JSON.stringify(notification));
        // Navigation logic could go here based on notification.notification.data
      });
    } catch (e) {
      console.warn('PushNotifications initialization failed:', e);
    }
  }
};

export const syncDeviceToken = async () => {
  try {
    if (Capacitor.isNativePlatform()) {
      const savedToken = localStorage.getItem('fcm_device_token');
      if (savedToken) {
        await registerDeviceToken(savedToken, Capacitor.getPlatform());
        console.log("Native push token automatically synced with backend.");
      }
    } else {
      // For web, if permission is already granted or default (asking first time)
      if (typeof Notification !== 'undefined' && (Notification.permission === 'granted' || Notification.permission === 'default')) {
        const token = await requestForToken();
        if (token) {
          await registerDeviceToken(token, 'web');
          console.log("Web push token automatically synced with backend.");
        }
      }
    }
  } catch (err) {
    console.error('Failed to sync device token:', err);
  }
};
